import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Returns true when running inside Capacitor native shell (iOS/Android).
 * Returns false for browser and PWA.
 */
export function isNative() {
	return Capacitor.isNativePlatform();
}

/**
 * Thin wrapper around Capacitor Preferences for JWT storage on native.
 * All methods are no-ops on web (guarded by isNative check at call site).
 */
export const NativeStorage = {
	async getToken() {
		const { value } = await Preferences.get({ key: 'auth_token' });
		return value;
	},

	async setToken(jwt) {
		await Preferences.set({ key: 'auth_token', value: jwt });
	},

	async clearToken() {
		await Preferences.remove({ key: 'auth_token' });
	},

	/**
	 * Removes ALL Capacitor Preferences keys. Not used in the logout flow —
	 * logout intentionally preserves biometric flags (`biometric_enrolled` /
	 * `biometric_prompt_declined`) per spec decision 4. Only call this from a
	 * full account-reset path that intentionally wipes everything (e.g., the
	 * "Not you? Sign in as a different user" flow on the login screen).
	 */
	async clearAll() {
		await Preferences.clear();
	},
};
